import { ModalType, openFipMigrationModal } from '@fiverr-private/pro_migration';

export const triggerSeamlessPaymentMigrationModal = () => {
    openFipMigrationModal({
        variant: ModalType.SeamlessPayment,
        payload: {
            source: 'seamless_payment_card_notification',
            biEnrichment: {
                source: 'seamless_payment_card_notification',
                pageElementName: 'seamless_payment_card_notification',
            },
        },
    });
};
